'use client';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { isEncryptedCardMask } from '@sola/shared-utils/checkout/credit-cards.js';

import { InputField } from '../input-field/input-field';
import {
  removeNonDigits,
  resetAchRoutingAndAccount,
  shouldRemoveSpecialChars,
} from './utils';

export const ACHRoutingNumber = ({ ...fieldProps }) => {
  const { t } = useTranslation();
  const formContext = useFormContext();
  const { setValue, getValues } = formContext;

  const clearValues = () => resetAchRoutingAndAccount(formContext);

  return (
    <InputField
      autoComplete="off"
      label={fieldProps.label || t('paymentMethods.ach.fields.routing')}
      name="ach-routing"
      inputMode="numeric"
      onFocus={(e) => {
        if (isEncryptedCardMask(e.target.value)) {
          clearValues();
        }
      }}
      onBlur={() => {
        setValue(fieldProps.name, getValues(fieldProps.name).trim(), {
          shouldValidate: true,
        });
      }}
      onChange={() => {
        const newVal = getValues(fieldProps.name);
        if (shouldRemoveSpecialChars(newVal)) {
          setValue(fieldProps.name, removeNonDigits(newVal));
        }
      }}
      validate={(value) => {
        if (isEncryptedCardMask(value)) {
          return true;
        }
        const trimValue = value?.trim();
        const startValue = Number(trimValue.substr(0, 2));
        if (
          startValue < 1 ||
          startValue > 32 ||
          (startValue >= 13 && startValue <= 20)
        ) {
          return t('checkout.form.ach.routingInvalid');
        }

        let sum = 0;
        for (let i = 0; i < trimValue.length; i += 3) {
          sum +=
            parseInt(trimValue.charAt(i), 10) * 3 +
            parseInt(trimValue.charAt(i + 1), 10) * 7 +
            parseInt(trimValue.charAt(i + 2), 10);
        }
        if (sum % 10 === 0) {
          return true;
        }
        return t('checkout.form.ach.routingInvalid');
      }}
      {...fieldProps}
    />
  );
};
